export default {
    getPreference: (state) => (key) => {
        return state.preferences[key];
    },
};
